import React from 'react';
import {Banner} from 'src/v2/components/common/Banner';
import type {SupportedCurrency, Wallet} from 'src/v2/state/types';
import {useSelector} from 'src/v2/state/store';
import {message, useIntl} from '@sail/intl';

const messages = {
  smartWalletWarning: message({
    id: 'crypto.payins.v2.smart_wallet_banner.warning',

    description:
      'Warning message when using a smart contract wallet that does not support gasless payments',

    defaultMessage:
      "Gasless payments aren't supported when using smart wallets. Network fees will apply.",
  }),
};

interface SmartWalletBannerProps {
  activeWallet: Wallet;
  selectedCurrency: SupportedCurrency;
}

export const SmartWalletBanner: React.FC<SmartWalletBannerProps> = ({
  activeWallet,
  selectedCurrency,
}) => {
  const intl = useIntl();
  const enableGaslessV2 = useSelector(
    (state) => state.featureFlags.enable_gasless_v2,
  );
  const spenderContractAddresses = useSelector(
    (state) => state.spenderContractAddresses,
  );

  const hasSpenderContract =
    !!spenderContractAddresses?.[
      `${selectedCurrency.assetCode}.${selectedCurrency.currencyNetwork}`
    ];

  if (
    !activeWallet.isSmartContractWallet ||
    !enableGaslessV2 ||
    !hasSpenderContract
  ) {
    return null;
  }

  return (
    <Banner
      message={intl.formatMessage(messages.smartWalletWarning)}
      variant="warning"
    />
  );
};
